import checkout from "./form2";

const {
  formField2: {
    taxpayers,
    taxCode,

    supportData,
  },
} = checkout;

const initialValues2 = {
  [taxpayers.name]: "",
  [taxCode.name]: "",

  [supportData.name]: false,
};

export default initialValues2;
